
import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const stats = [
    {
      value: 800,
      label: "Satisfied Clients",
      icon: "😊",
      suffix: "+",
    },
    {
      value: 2000,
      label: "Projects Completed",
      icon: "🚀",
      suffix: "+",
    },
    {
      value: 5,
      label: "Years of Experience",
      icon: "⏱️",
      suffix: "+",
    },
    {
      value: 15,
      label: "Team Members",
      icon: "👥",
      suffix: "+",
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="py-16 bg-gradient-to-r from-blue-50 to-blue-100"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Our <span className="text-blue-600">Performance</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Numbers that demonstrate our commitment to excellence and success
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-10">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-lg p-4 md:p-6 text-center transform transition-all hover:shadow-xl hover:-translate-y-2"
            >
              <div className="text-3xl md:text-4xl mb-3 md:mb-4 mx-auto">{stat.icon}</div>
              <div className="text-3xl md:text-5xl font-bold text-blue-600 mb-2">
                {isVisible ? (
                  <CountUp end={stat.value} duration={2.5} suffix={stat.suffix} />
                ) : (
                  `0${stat.suffix}`
                )}
              </div>
              <p className="text-base md:text-lg text-gray-600">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
